import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';

/**
 * Coordinates displaying of the spinner-overlay
 *
 * @export
 * @class SpinnerService
 */
@Injectable({
  providedIn: 'root'
})
export class SpinnerService {

  private _isStarted = false;

  private _queue: Array<Promise<any>>;

  private _behaviourSubject: BehaviorSubject<boolean>;

  /**
   * Return the observeable which emits wether some work is in progress (true) or not (false)
   *
   * @readonly
   * @type {Observable<boolean>}
   * @memberof SpinnerService
   */
  public get stream(): Observable<boolean> {
    return this._behaviourSubject.asObservable();
  }

  constructor() {
    this._behaviourSubject = new BehaviorSubject<boolean>(false);
    this._queue = [];
  }

  /**
   * Hand over a promis that must be fulfilled or rejected before removing the spinner
   *
   * @template T
   * @param {Promise<T>} promise
   * @memberof SpinnerService
   */
  public waitFor<T>(promise: Promise<T>) {
    this._queue.push(promise);

    if (!this._isStarted) {
      this.setState(true);
      this.run();
    }
  }

  /**
   * Run the loop in order to await all promises
   *
   * @private
   * @memberof SpinnerService
   */
  private run() {
    if (this._queue.length > 0) {
      this._queue.pop().then(
        () => { this.run(); },
        () => { this.run(); });
    } else {
      this.setState(false);
    }
  }

  /**
   * Set {_isStarted} and emit value on {_behaviourSubject}
   *
   * @private
   * @param {boolean} state
   * @memberof SpinnerService
   */
  private setState(state: boolean) {
    this._isStarted = state;
    this._behaviourSubject.next(state);
  }

}
